import { UIOnlineFriendController } from '../../../shared/scripts/ui_friends/UIOnlineFriendController.ts';
import { UICornerNotificationController } from '../ui_corner_notification/UICornerNotificationController.ts';
import { UIUrlController } from '../../../shared/scripts/ui_html/UIUrlController.ts';
export class UIWOnlineFriendController extends UIOnlineFriendController {
    updateFriendOnlineStatus(friendData) {
        var _this_roomController;
        (_this_roomController = this.roomController) === null || _this_roomController === void 0 ? void 0 : _this_roomController.updateFriendOnlineStatus(friendData);
        super.updateFriendOnlineStatus(friendData);
    }
    updateAllFriendsOnlineStatus(friends) {
        var _this_roomController;
        (_this_roomController = this.roomController) === null || _this_roomController === void 0 ? void 0 : _this_roomController.updateAllFriendsOnlineStatus(friends);
        super.updateAllFriendsOnlineStatus(friends);
    }
    friendRespondedToRoomInvite(responseData) {
        var _this_roomController;
        if (responseData.response) return;
        super.friendRespondedToRoomInvite(responseData);
        if (UIUrlController.getRoomIdFromUrl() != responseData.roomId.toLocaleLowerCase()) return;
        (_this_roomController = this.roomController) === null || _this_roomController === void 0 ? void 0 : _this_roomController.toggleFriendInviteButtonState(responseData.responderUserId, true);
    }
    roomInviteSentToFriendSuccessfully(receiverUserId) {
        var _this_roomController;
        const roomId = UIUrlController.getRoomIdFromUrl();
        if (!roomId) return;
        (_this_roomController = this.roomController) === null || _this_roomController === void 0 ? void 0 : _this_roomController.toggleFriendInviteButtonState(receiverUserId, false);
    }
    // eslint-disable-next-line class-methods-use-this
    showNotification(icon, translationObj) {
        UICornerNotificationController.showNotification(icon, translationObj);
    }
    showJoinRoomNotification(icon, translationObj, roomInvite) {
        this.showNotification(icon, translationObj);
    }
    constructor(roomController, notificationPanelController){
        super(notificationPanelController);
        this.roomController = roomController;
    }
}
